<template>
  <section class="relative bg-[#F5F5F9] text-[#333] py-20 px-8 md:px-16 animate-fade-in">
    <!-- Decorative corners -->
    <div class="absolute top-4 left-4">
      <CornerDecoration />
    </div>
    <div class="absolute top-[7px] right-[7px] flex flex-col items-end">
      <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
      <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
    </div>

    <!-- Section header -->
    <header class="text-center mb-16">
      <h2 class="text-5xl font-bold text-[#222] animate-slide-up">
        Meet Our Team – ProjectSpot from Poznań
      </h2>
      <p class="mt-3 text-lg text-[#555] animate-slide-up delay-200">
        We are a team of professionals passionate about architecture, renovations, and interior design.
      </p>
      <div class="w-20 h-[2px] bg-[#E9A53D] mx-auto mt-4"></div>
    </header>

    <!-- "Who we are" section -->
    <section class="grid grid-cols-1 md:grid-cols-12 gap-8 items-center mb-16" aria-label="About ProjectSpot">
      <figure class="md:col-span-5 relative h-[400px] rounded-xl overflow-hidden shadow-lg">
        <img
            src="/images/components/image1.jpg"
            alt="ProjectSpot team – renovation and design specialists from Poznań"
            class="w-full h-full object-cover"
        />
      </figure>

      <article class="md:col-span-7 text-center md:text-left">
        <h3 class="text-3xl font-semibold text-[#222]">Who are we?</h3>
        <div class="w-12 h-[2px] bg-[#E9A53D] my-4 mx-auto md:mx-0"></div>
        <p class="text-[#555] leading-relaxed">
          We are a team with over a decade of experience in the construction and design industry.
          We combine technical knowledge with aesthetics to carry out even the most demanding projects.
          Based in Poznań, we operate throughout Greater Poland.
        </p>
      </article>
    </section>

    <!-- "What we do" section -->
    <section class="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" aria-label="Scope of activity">
      <article class="text-center md:text-left">
        <h3 class="text-3xl font-semibold text-[#222]">
          What do we do? Renovations, finishing, and architecture
        </h3>
        <div class="w-12 h-[2px] bg-[#E9A53D] my-4 mx-auto md:mx-0"></div>
        <p class="text-[#555] leading-relaxed">
          ProjectSpot provides a comprehensive approach to construction and interior design projects.
          We assist at every stage: from choosing a plot, through architectural design, to turnkey finishing.
          Everything we do is focused on your needs and comfort.
        </p>
      </article>

      <figure class="relative h-[400px] rounded-xl overflow-hidden shadow-lg">
        <img
            src="/images/components/image2.jpeg"
            alt="Design and execution of construction works – ProjectSpot, Poznań"
            class="w-full h-full object-cover"
        />
      </figure>
    </section>

    <!-- Strengths section -->
    <section class="mt-16 text-center" aria-label="Our strengths">
      <h3 class="text-3xl font-semibold text-[#222]">Our Strengths</h3>
      <div class="w-12 h-[2px] bg-[#E9A53D] mx-auto my-4"></div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
        <article class="bg-white p-6 rounded-md shadow-sm hover:shadow-xl transition relative">
          <CornerDecoration />
          <h4 class="text-xl font-semibold text-[#222]">COMPREHENSIVENESS</h4>
          <p class="text-[#555] mt-2">Consulting and support at every stage – from concept to completion.</p>
        </article>

        <article class="bg-white p-6 rounded-md shadow-sm hover:shadow-xl transition relative">
          <CornerDecoration />
          <h4 class="text-xl font-semibold text-[#222]">VERSATILITY</h4>
          <p class="text-[#555] mt-2">A team of experienced and qualified professionals in multiple construction fields.</p>
        </article>

        <article class="bg-white p-6 rounded-md shadow-sm hover:shadow-xl transition relative">
          <CornerDecoration />
          <h4 class="text-xl font-semibold text-[#222]">RELIABILITY</h4>
          <p class="text-[#555] mt-2">Timeliness, transparency, and guaranteed quality in every project we complete.</p>
        </article>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  name: 'AboutSection',
  components: {
    CornerDecoration: {
      template: `
        <div class="absolute top-[0px] left-[0px] flex flex-col">
          <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
          <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
        </div>
        <div class="absolute bottom-[0px] right-[0px] flex flex-col items-end">
          <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
          <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
        </div>
      `
    }
  }
}
</script>

<style scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-fade-in {
  animation: fadeIn 1s ease-out forwards;
}
.animate-slide-up {
  animation: slideUp 0.8s ease-out forwards;
}
.delay-200 {
  animation-delay: 0.2s;
}
</style>
